import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import { UserRoutes } from '../modules/users/UserRoutes'
import { Profile } from '../modules/profile/Profile'
import { useAuth } from '../modules/auth'
import { ExtractorsRoutes } from '../modules/exctractors/ExtractorsRoutes'
import { LicencesRoutes } from '../modules/licences/LicencesRoutes'
import { TenantsRoutes } from '../modules/tenants/TenantRoutes'

const PrivateRoutes = () => {
  const ROLE_ADMIN = parseInt(process.env.REACT_APP_ROLE_ADMIN+"");
  const ROLE_MANAGER = parseInt(process.env.REACT_APP_ROLE_MANAGER+"");
  const ROLE_EMPLOYEE = parseInt(process.env.REACT_APP_ROLE_EMPLOYEE+"");
  //const Profile = lazy(() => import('../modules/profile/Profile'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const {checkAuthorization} = useAuth();
 
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/tenants' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='profile' element={<Profile />} />
        {/* Lazy Modules */}

        {checkAuthorization([ROLE_ADMIN]) &&  <Route
          path='user/*'
          element={
            <SuspensedView>
              <UserRoutes />
            </SuspensedView>
          }
        />}

        {checkAuthorization([ROLE_ADMIN]) &&  <Route
          path='extractors/*'
          element={
            <SuspensedView>
              <ExtractorsRoutes />
            </SuspensedView>
          }
        />}
         {checkAuthorization([ROLE_ADMIN]) &&  <Route
          path='licences/*'
          element={
            <SuspensedView>
              <LicencesRoutes />
            </SuspensedView>
          }
        />}
        {checkAuthorization([ROLE_ADMIN]) &&  <Route
          path='tenants/*'
          element={
            <SuspensedView>
              <TenantsRoutes />
            </SuspensedView>
          }
        />}
        <Route
          path='crafted/pages/profile'
          element={
            <SuspensedView>
              <Profile />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
